import ajax from "../utils/request";

const CheckPrizeApi = {
  /********************************金刚区配置列表*********************************** */
  // 获取金刚区列表
  list(params) {
    return ajax({
      url: "/checkprize/list",
      type: "post",
      params: params,
    });
  },
  save(param) {
    return ajax({
      url: "/checkprize/add",
      type: "post",
      params: param,
    });
  },
  update(param) {
    return ajax({
      url: "/checkprize/update",
      type: "post",
      params: param,
    });
  },
  remove(param) {
    return ajax({
      url: "/checkprize/del",
      type: "post",
      params: param,
    });
  },
  copy(param) {
    return ajax({
      url: "/checkprize/copy",
      type: "post",
      params: param,
    });
  },
  field(param) {
    return ajax({
      url: "/checkprize/field",
      type: "post",
      params: param,
    });
  }
};

export default CheckPrizeApi;
